module.exports = __webpack_public_path__ + "static/desktop/img/hardback-en.0e40c241.png";